/**
 * Event transitionend fires for each transitioned property which
 * varies in execution time despite specified CSS duration.
 * @param {HTMLElement} el
 * @param {string} property
 * @param {Function} callback
 * @param {number} forceTriggerAfter ms
 * @returns {unregister}
 */
function onPropertyTransitionEndOnce(el, property, callback, forceTriggerAfter = 300) {
    let timer = null;

    function handler(event) {
        if (event.propertyName === property) {
            unregister();
            callback();
        }
    }

    function unregister() {
        if (timer) {
            clearTimeout(timer);
        }

        el.removeEventListener('transitionend', handler);
    }

    el.addEventListener('transitionend', handler);

    timer = setTimeout(() => {
        unregister();
        callback();
        timer = null;
    }, forceTriggerAfter);

    return unregister;
}

function createEvent(name, detail = undefined) {
    if (typeof window.CustomEvent === 'function') {
        return new window.CustomEvent(name, {
            bubbles: true,
            cancelable: true,
            detail,
        });
    }

    const evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(name, true, true, detail);

    return evt;
}

export {
    onPropertyTransitionEndOnce,
    createEvent,
};
